// extracted by mini-css-extract-plugin
export default {"emojiSpan":"Emoji_emojiSpan__wCqQ1"};